import { render } from "./ComboLeiConsideracao.vue?vue&type=template&id=486014b4&ts=true"
import script from "./ComboLeiConsideracao.vue?vue&type=script&lang=ts"
export * from "./ComboLeiConsideracao.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DefesaCivil\\FrontEnd\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__